import {doPost} from './Base';


const logIn = async (username, password) => {
  return await doPost('/login', {username: username, password: password});
};


const signUp = async (email, first_name, last_name, signup_code, domain, subdomain) => {
  const body = {
    email: email,
    first_name: first_name,
    last_name: last_name,
    signup_code: signup_code,
    domain: domain,
    subdomain: subdomain
  };
  return await doPost('/signup', body);
};


const demoSignUp = async (email) => {
  const body = {
    email: email,
    is_demo: true
  };
  return await doPost('/signup', body);
};


const verify = async (code, password) => {
    return await doPost('/verify_account', {verify_code: code, password: password});
};


export {logIn, signUp, demoSignUp, verify};
export default logIn;
